<template>
  <div class="bg-slate-200 d-none">
  </div>
  <router-view/>
</template>